module.exports = __webpack_public_path__ + "static/media/SnowSun13d.ca039af1.png";